import React, { useState } from "react";

/**
 * Renders the CAA logo image from /logo.png.
 * If it fails to load, falls back to the "CRANE AUCTIONS" text wordmark.
 * `height` in pixels; width scales automatically (preserves aspect ratio).
 */
export default function Logo({ height = 40, className = "", testId = "caa-logo" }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span
        className={`caa-wordmark inline-flex items-baseline gap-1 leading-none ${className}`}
        data-testid="caa-wordmark"
        style={{ fontSize: Math.round(height * 0.5) }}
      >
        <span className="font-extrabold tracking-tight" style={{ color: "var(--caa-teal-deep)" }}>
          CRANE
        </span>
        <span className="font-extrabold tracking-tight" style={{ color: "var(--caa-charcoal)" }}>
          AUCTIONS
        </span>
      </span>
    );
  }

  return (
    <img
      src="/logo.png"
      alt="Crane Auctions Australia"
      onError={() => setFailed(true)}
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid={testId}
    />
  );
}
